<template>
  <el-dialog
    class="hb-apply-result-dialog"
    title="申请结果"
    :visible.sync="dialogVisible"
    width="50%"
    center
    destroy-on-close
    @close="beforeClose"
    @open="beforeOpen"
  >
    <el-form label-width="85px">
      <el-form-item label="项目:" :disabled="!editable">
        <div>{{ projectName }}</div>
      </el-form-item>
      <el-form-item label="结果类型:" required :disabled="!editable">
        <div v-if="editable">
          <el-radio v-model="form.apply_result" label="5" :disabled="!editable"
            >uncon-offer</el-radio
          >
          <el-radio v-model="form.apply_result" label="6" :disabled="!editable"
            >con-offer</el-radio
          >
          <el-radio v-model="form.apply_result" label="7" :disabled="!editable"
            >被拒</el-radio
          >
        </div>
        <div v-else>
          {{ resultStatusCN }}
        </div>
      </el-form-item>
      <el-form-item
        v-if="form.apply_result == 5 || form.apply_result == 6"
        label="奖学金:"
        :disabled="!editable"
      >
        <el-input
          v-model="form.scholarship"
          placeholder="如有则输入奖学金信息"
          :disabled="!editable"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注:" :disabled="!editable">
        <el-input
          v-model="form.result_remarks"
          type="textarea"
          autosize
          placeholder="请输入备注"
          :disabled="!editable"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请凭证:" required :disabled="!editable">
        <el-upload
          :disabled="!editable"
          :auto-upload="false"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :on-preview="handlePreview"
          multiple
          :file-list="fileList"
          :limit="5"
          action="#"
        >
          <el-button v-if="editable" size="small">点击上传</el-button>
          <div v-if="editable" slot="tip" class="el-upload__tip">
            上传能明确表述申请结果的截图或视频等重要信息(支持多文件)
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" v-if="editable == true">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmAction" :loading="submitLoading"
        >确定</el-button
      >
    </span>
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>
  </el-dialog>
</template>

<script>
import { addSchoolApplyResultApi } from "@/api/mycenter_studyabroad.js";
import { upload } from "@/api/public";
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';
export default {
  name: "HBApplyResultDialog",
  components: {
    HBFilePreview
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    defaultData: undefined,
  },
  data() {
    return {
      previewUrl:null,
      previewName:null,
      fileList: [],
      submitLoading: false,
      user_school_choice_id: null,
      form: {
        apply_result: null,
        scholarship: "",
        result_remarks: "",
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("updateVisible", val);
      },
    },
    projectName: {
      get() {
        if (this.defaultData) {
          return (
            this.defaultData.project_name +
            "-" +
            this.defaultData.school_name +
            "-" +
            this.defaultData.country_name
          );
        } else {
          return "";
        }
      },
    },
    resultStatusCN: {
      get() {
        if (this.form.apply_result == 5) {
          return "uncon-offer";
        } else if (this.form.apply_result == 6) {
          return "con-offer";
        } else if (this.form.apply_result == 7) {
          return "被拒";
        } else {
          return "";
        }
      },
    },
  },
  methods: {
    confirmAction() {
      if (this.form.apply_result == null) {
        this.$message.error("请选择结果类型");
        return;
      }
      if (!this.fileList || this.fileList.length == 0) {
        this.$message.error("请上传申请结果凭证");
        return;
      }

      const fileUploadList = [];
      this.fileList.forEach((element) => {
        const formser = new FormData(); // 获取表单的参数
        formser.append("path", "admin_file");
        formser.append("file", element.raw);
        fileUploadList.push(upload(formser));
      });
      this.submitLoading = true;
      Promise.all(fileUploadList)
        .then((datas) => {
          const files = [];
          this.fileList.forEach((item, index) => {
            files.push({ url: datas[index].data, name: item.name });
          });
          addSchoolApplyResultApi(
            this.user_school_choice_id,
            this.form.apply_result,
            this.form.scholarship,
            this.form.result_remarks,
            files
          )
            .then((d) => {
              this.submitLoading = false;
              this.$message.success("成功添加申请结果");
              this.successCallback();
              this.dialogVisible = false;
            })
            .catch((error) => {
              this.submitLoading = false;
              this.$message.error(error.message);
            });
        })
        .catch((error) => {
          this.submitLoading = false;
          this.$message.error(error.message);
        });
    },
    handleRemove(file, fileList) {
      const index = fileList.indexOf(file);
      if (index >= 0) {
        this.fileList.splice(index, 1);
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList || [];
    },
    handlePreview(file) {
      if (file.url) {
        this.previewUrl = file.url
        this.previewName = file.name
        // window.location.href = file.url;
      } else {
      }
    },
    beforeClose() {
      this.user_school_choice_id = null;
      this.form = {
        apply_result: null,
        scholarship: "",
        result_remarks: "",
      };
      this.fileList = [];
    },
    beforeOpen() {
      if (this.defaultData) {
        this.user_school_choice_id = this.defaultData.id;
        if (!this.editable) {
          this.form.apply_result = this.defaultData.status || null;
          if (this.defaultData.apply_school_choice) {
            this.form.scholarship =
              this.defaultData.apply_school_choice.scholarship || "";
            this.form.result_remarks =
              this.defaultData.apply_school_choice.result_remarks || "";
            if (this.defaultData.apply_school_choice.result_apply_annex) {
              const list = JSON.parse(
                this.defaultData.apply_school_choice.result_apply_annex
              );
              list.forEach((item) => {
                this.fileList.push({ name: item.name, url: item.url });
              });
            }
          }
        }
      }
    },
    successCallback() {
      this.$emit("successCallback", null);
    },
  },
};
</script>

<style lang="scss" scoped>
.hb-apply-result-dialog {
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/HBApplyResultDialog/HBApplyResultDialog.vue